import {onDocumentLoaded} from "@plaudit/frontend-apis";

import { MainMenu } from './src/mainMenu';
import { Menu } from './src/menu';

onDocumentLoaded(() => {
	const mainMenu = document.getElementById("main-menu");
	if (!mainMenu) return;

	// NOTE: toggle id syntax is backwards to preserve URL slugs
	const toggleOpen = document.getElementById('main-menu-close');

	for (const element of mainMenu.querySelectorAll<HTMLElement>(".wp-block-plaudit-menu:not(.js-ready)")) {
		new Menu(element);
	}

	if (toggleOpen) {
		new MainMenu(mainMenu, toggleOpen, {
			toggles: '.main-menu-toggle',
			focusLock: {
				dialog: '.main-menu',
				return: '.main-menu-toggle--open',
				toggle: '.main-menu-toggle--close'
			},
			styleClass: {
				menuOpen: 'hasMenuOpen'
			},
			duration: 400,
			easing: 'easeOutExpo'
		});
	}
});
